import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="absolute top-0 left-0 right-0 z-50 bg-transparent">
      <div className="container mx-auto px-6 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <img 
              src="https://static.readdy.ai/image/2e9ecc346a2ca29966c0e167990e2bed/ac17c2410a5c5bdc3182efc3680fe414.png" 
              alt="handgepackt Logo" 
              className="h-28 w-auto drop-shadow-lg"
            />
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <a href="#services" className="text-white hover:text-gray-200 transition-colors cursor-pointer whitespace-nowrap font-medium drop-shadow-lg">
              Leistungen
            </a>
            <a href="#about" className="text-white hover:text-gray-200 transition-colors cursor-pointer whitespace-nowrap font-medium drop-shadow-lg">
              Über uns
            </a>
            <a href="#process" className="text-white hover:text-gray-200 transition-colors cursor-pointer whitespace-nowrap font-medium drop-shadow-lg">
              Unser Prozess
            </a>
            <a href="#contact" className="text-white hover:text-gray-200 transition-colors cursor-pointer whitespace-nowrap font-medium drop-shadow-lg">
              Kontakt
            </a>
            <a href="tel:+4926422913998" className="bg-white/90 backdrop-blur-sm text-black px-6 py-3 rounded-lg hover:bg-white transition-all cursor-pointer whitespace-nowrap font-semibold shadow-lg">
              Angebot anfordern
            </a>
          </nav>

          <button 
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer bg-black/20 backdrop-blur-sm rounded-lg"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className="ri-menu-line text-xl text-white drop-shadow-lg"></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden mt-6 pb-4 bg-black/80 backdrop-blur-sm rounded-lg p-4">
            <nav className="flex flex-col space-y-4">
              <a href="#services" className="text-white hover:text-gray-200 transition-colors cursor-pointer font-medium">
                Leistungen
              </a>
              <a href="#about" className="text-white hover:text-gray-200 transition-colors cursor-pointer font-medium">
                Über uns
              </a>
              <a href="#process" className="text-white hover:text-gray-200 transition-colors cursor-pointer font-medium">
                Unser Prozess
              </a>
              <a href="#contact" className="text-white hover:text-gray-200 transition-colors cursor-pointer font-medium">
                Kontakt
              </a>
              <a href="tel:+4926422913998" className="bg-white text-black px-6 py-3 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap w-fit font-semibold">
                Angebot anfordern
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
